<template>
    <div class="form-agency-contacts">
        <div class="row">
            <!-- <div class="col-xl-3 col-lg-3 col-md-3 agency-contacts-column">
                <div class="form-field form-field--text">
                    <label for="first-name">First name*</label>
                    <input v-model="form.firstname" @change="validateForm('firstname')" type="text" id="first-name" name="firstname"/>
                    <span class="error" v-if="validate.firstname && touched">{{ validate.firstname }}</span>
                </div>
            </div>
            <div class="col-xl-3 col-lg-3 col-md-3 agency-contacts-column">
                <div class="form-field form-field--text">
                    <label for="last-name">Last name*</label>
                    <input v-model="form.lastname" @change="validateForm('lastname')" type="text" id="last-name" name="lastname" />
                    <span class="error" v-if="validate.lastname && touched">{{ validate.lastname }}</span>
                </div>
            </div>
            <div class="col-xl-3 col-lg-3 col-md-3 agency-contacts-column agency-contacts-checkboxes">
                <div class="form-field checkbox-wrap checkbox-wrap--main-billing-contact">
                    <label>&nbsp;</label>
                    <input type="checkbox" v-model="form.mainContact" id="main-billing-contact"
                           class="main-billing-contact"
                           name="main_billing_contact"/>
                    <label for="main-billing-contact">
                        <i class="icon icon-checkmark"></i>
                    </label>
                    Main billing contact
                </div>
                <div class="form-field checkbox-wrap checkbox-wrap--send-emails">
                    <label>&nbsp;</label>
                    <input type="checkbox" v-model="form.sendEmails" id="send-emails"
                           class="send-emails"
                           name="send-emails"/>
                    <label for="send-emails">
                        <i class="icon icon-checkmark"></i>
                    </label>
                    Send e-mails
                </div>
            </div> -->
            <div class="col-xl-10 col-lg-9 col-md-9"></div>
            <div class="col-xl-2 col-lg-3 col-md-3 agency-contacts-column">
                <div class="btn-wrap">
                    <button v-if="action === `create`" @click.prevent="toggleContactModal" class="btn btn--gray">Add contact</button>
                    <button v-if="action === `edit`" @click.prevent="updateContact" class="btn btn--gray">Update contact</button>
                </div>
            </div>
        </div>
        <!--<div class="row">
            <div class="col-xl-3 col-lg-3 col-md-3 agency-contacts-column">
                <div class="form-field form-field--text">
                    <label for="email">Email*</label>
                    <input v-model="form.email" type="text" id="email" name="email" @change="validateForm('email')" />
                    <span class="error" v-if="validate.email && touched">{{ validate.email }}</span>
                </div>
            </div>
            <div class="col-xl-3 col-lg-3 col-md-3 agency-contacts-column">
                <div class="form-field form-field--text">
                    <label for="title">Title</label>
                    <input v-model="form.title" type="text" id="title" name="title"/>
                </div>
            </div>
            <div v-show="action === `create`" class="col-xl-3 col-lg-3 col-md-3 agency-contacts-column">
                <div class="form-field form-field__select">
                    <label for="role">Role</label>
                    <select v-model="form.role" name="role" id="role" class="js-select-custom">
                        <option value="" selected>Choose role</option>
                        <option v-for="role of roles" :value="role.id">{{ role.name }}</option>
                    </select>
                </div>
            </div>
        </div> -->
        <div class="row">
            <div class="col-xl-12 col-lg-12 col-md-12">
                <div class="table-wrap">
                    <table class="table table--tabs">
                        <thead>
                        <tr>
                            <th>Last name</th>
                            <th>First name</th>
                            <th>Title</th>
                            <th>E-mail</th>
                            <th>Main contact
                                <span>
                                    <i class="icon icon-down-arrow"></i>
                                </span>
                            </th>
                            <th>Role</th>
                            <th>Action</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-if="loading">
                            <td colspan="16">
                                <clip-loader
                                    :loading="loading"
                                    :color="'#ec4657'"
                                    :size="'45px'"
                                ></clip-loader>
                            </td>
                        </tr>
                        <tr v-else-if="!users.length && !loading">
                            <td colspan="16"><center>No data</center></td>
                        </tr>
                        <tr v-else-if="users.length"
                            v-for="(user, index) of users" :key="index">
                            <td>{{ user.last_name }}</td>
                            <td>{{ user.first_name }}</td>
                            <td>{{ user.title }}</td>
                            <td>{{ user.email }}</td>
                            <td class="checkbox">
                                <div class="form-field checkbox-wrap">
                                    <input disabled :checked="user.main_contact" type="checkbox"
                                           :id="`user_main_contact_`+ user.id"
                                           value="" name="master_invoice[]"/>
                                    <label :for="`user_main_contact_`+ user.id">
                                        <i class="icon icon-checkmark"></i>
                                    </label>
                                </div>
                            </td>

                            <td>
                                <p v-for="role of user.role">{{ role }}</p>
                            </td>
                            <td>
                                <button @click="editUserContact(user)" class="btn btn--icon" type="button">
                                    <i class="icon icon-pencil"></i>
                                </button>
                                <button @click="deleteUserContact(user)" class="btn btn--icon" type="button">
                                    <i class="icon icon-trash"></i>
                                </button>
                                <div class="error" v-if="error && user.main_contact">{{ error }}</div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <addContactModal v-if="isAddContact" :closeModal="toggleContactModal" />
    </div>
</template>

<script>
import axios from "axios";
import ClipLoader from "vue-spinner/src/ClipLoader";
import addContactModal from "./addContactModal.vue";

export default {
    name: "contactTab",

    props: ['partner', 'roles'],

    components: {
        ClipLoader,
        addContactModal
    },

    computed: {
        isValidEmail() {

            if(this.form.email) {
                return !/^[^@]+@\w+(\.\w+)+\w$/.test(this.form.email);
            }
            
        }
    },  

    data() {
        return {
            loading: false,
            form: {
                firstname: null,
                lastname: null,
                email: null,
                title: null,
                mainContact: false,
                sendEmails: false,
                salesPerson: false,
                role: "",
                
            },

            users: [],
            touched: false,
            action: 'create',
            editableUser: null,
            error: '',
            validate: {
                email: `The "email" field is required`,
                firstname: `The "firstname" field is required`,
                lastname: `The "lastname" field is required`,
            },
            isAddContact: false,
        }
    },

    mounted() {
        this.getUserList();
    },
    watch: {
        'form.mainContact': function (newVal){
            if (newVal)
                this.form.sendEmails = true;
        },
    },
    methods: {

        addContact() {

            if(this.validate.email || this.validate.firstname || this.validate.lastname) {
                alert("Please check all required fields before add contact")
                this.touched = true;
                return
            }

            this.error = '';
            axios
                .post("/partners/create-contact", {
                    form: this.form,
                    agencyID: this.agency.id
                })
                .then((res) => {
                    this.loading = false;

                    this.cleanForm();

                    this.getUserList();
                })
                .catch((err) => {
                    this.loading = false;
                });
        },
        updateContact() {
            this.error = '';
            axios
                .post("/partners/update-contact", {
                    form: this.form,
                    partnerID: this.partner.id,
                    userID: this.editableUser
                })
                .then((res) => {
                    this.loading = false;

                    if (res.data.isSuccess) {
                        this.cleanForm();

                        this.getUserList();
                    } else {
                        this.error = res.data.message;
                    }
                })
                .catch((err) => {
                    this.loading = false;
                });
        },
        getUserList() {
            this.loading = true;

            axios
                .get("/partners/getPartnersUsers/" + this.partner.id)
                .then((res) => {
                    this.loading = false;

                    this.users = res.data;
                })
                .catch((err) => {
                    this.loading = false;
                });
        },
        deleteUserContact(user) {
            this.error = '';
            if(!user.main_contact) {
                if (confirm("Do you really want to delete?")) {

                    axios
                        .post("/users/deleteContact", {
                            id: user.id,
                        })
                        .then((res) => {
                            this.loading = false;
                            if (res.data.isSuccess) {
                                this.getUserList();
                            }
                        })
                        .catch((err) => {
                            console.error("Delete user error", err);
                            this.loading = false;
                        });
                } else {
                    this.getUserList();
                }
            } else {
                this.error = "Main contact can't be deleted"
            }
        },

        editUserContact(user) {
            this.error = '';
            this.action = 'edit';

            this.editableUser = user.id;

            this.form.firstname = user.firstname;
            this.form.lastname = user.lastname;
            this.form.email = user.email;
            this.form.title = user.title;
            this.form.mainContact = user.main_contact;
            this.form.salesPerson = user.sales_person;
            this.form.sendEmails = user.send_emails;
        },

        cleanForm() {
            this.editableUser = null;
            this.action = 'create';

            this.form.firstname = null;
            this.form.lastname = null;
            this.form.email = null;
            this.form.title = null;
            this.form.mainContact = false;
            this.form.sendEmails = false;
            this.form.salesPerson = false;
            this.form.role = '';
        },

        validateForm(field = "") {

            this.validate[field] = null;
            this.touched = true;

            if(!this.form[field]) {
                this.validate[field] = `The "${field}" field is required`;
            }
            
            if(field === "email" && this.isValidEmail)  {
                this.validate[field] = "The Email must be a valid email address.";
                return
            }
             
        },

        toggleContactModal() {
            this.isAddContact = !this.isAddContact
        }
    }
}
</script>

<style scoped>

</style>
